// import React, { useState } from 'react';

interface NavigationProps {
  onToggle: () => void;
  activeSection: string;
  setActiveSection: (section: string) => void;
}

const Navigation: React.FC<NavigationProps> = ({ 
  onToggle,
  activeSection,
  setActiveSection,
 }) => {
  
  const handleClick = (id: string) => {
    if (id === "portfolio") {
      onToggle();
    } else {
      setActiveSection(id);
    }
  };


  return (
    <nav className="sidebar">
      <div className="menu pb-1">
        {[
          { id: "head", icon: "fa-home", tooltip: "Home" },
          { id: "portfolio", icon: "fa-gamepad", tooltip: "Projects" },
          { id: "resume", icon: "fa-graduation-cap", tooltip: "Resume" },
          { id: "website", icon: "fa-globe", tooltip: "Website" },
        ].map(({ id, icon, tooltip }) => (
          <div className="pb-1 tooltip" key={id}>
            <div
              className={`menu-icon control ${
                activeSection === id ? "active-btn" : ""
              }`}
              data-id={id}
              onClick={() => handleClick(id)}
            >
              <a href="#">
                <i className={`fas ${icon}`}></i>
              </a>
            </div>
            <div className="tooltiptext">{tooltip}</div>
          </div>
        ))}
      </div>
    </nav>
  );
};

export default Navigation;
